import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { SmartImage } from "@/components/SmartImage";
import { toast } from "sonner";

export const ProductCard = ({ product, priority = false }) => {
  const { addItem } = useCart();
  return (
    <div
      data-testid="product-card"
      className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(216,27,96,0.06)] hover:shadow-[0_10px_30px_rgba(216,27,96,0.12)] transition-all group flex flex-col"
    >
      <Link to={`/product/${product.slug}`} className="relative block overflow-hidden">
        {product.discount_percent > 0 && (
          <span className="absolute top-3 left-3 z-10 bg-[#FF0055] text-white text-[10px] font-bold px-2.5 py-1 rounded-full shadow-md">
            {product.discount_percent}% OFF
          </span>
        )}
        <SmartImage
          src={product.images?.[0]}
          alt={product.name}
          width={500}
          sizes="(max-width: 768px) 50vw, 25vw"
          widths={[240, 320, 480, 640]}
          aspectRatio="4/5"
          priority={priority}
          blurDataURL={product.blur_data_url}
          className="w-full aspect-[4/5] object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </Link>
      <div className="p-3 flex flex-col gap-2 flex-grow">
        <Link to={`/product/${product.slug}`}>
          <h3 className="font-serif text-[15px] text-[#2D0A22] leading-snug line-clamp-2 hover:text-[#D81B60] transition-colors">
            {product.name}
          </h3>
        </Link>
        <div className="flex items-baseline gap-2 mt-auto">
          <span className="font-bold text-[#D81B60] text-base">₹{product.price.toLocaleString("en-IN")}</span>
          {product.original_price && (
            <span className="text-xs line-through text-[#8E6377]">₹{product.original_price.toLocaleString("en-IN")}</span>
          )}
        </div>
        <button
          data-testid="add-to-cart-button"
          onClick={() => { addItem(product); toast.success(`${product.name} added to bucket`); }}
          className="mt-1 w-full py-2 rounded-xl text-sm font-semibold bg-[#FCE4EC] text-[#D81B60] hover:bg-[#D81B60] hover:text-white transition-colors"
        >
          Add to Bucket
        </button>
      </div>
    </div>
  );
};
